<template>
  <div class="pick-list">
    <ul @scroll.passive="monitorIsBottom" v-if="!showLoading">
      <pick-item-container
        v-for="(item, index) in list"
        :key="index"
        :item="item"
        :selected="isSelected(item)"
        @click.native="choose(item)"
      >
      </pick-item-container>
    </ul>
    <div v-if="showNoData && !showLoading" class="no-info">
      <img v-if="platform === 'zlj'" src="../../../../assets/img/wudingdan.png" alt="" />
      <z-stance v-else type="general" :show-info="false"/>
      <p>还没有订单哦</p>
    </div>
    <!-- <img
      v-if="showLoading"
      src="../../../../assets/img/loading-common2.gif"
      :style="{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '30px',
        height: '30px',
      }"
    /> -->
  </div>
</template>

<script>
import { Stance } from '@zz-common/zz-ui';
import { $, isScrollToBottom, getPlatform } from '../../../../lib/utils'
import PickItemContainer from '../PickItemContainer'

export default {
  name: 'PickList',
  props: {
    list: {
      type: Array,
      default: function() {
        return []
      }
    },
    showLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // 当前选中的
      currentSelected: null,
      showNoData: false,
      platform: getPlatform()
    }
  },
  watch: {
    // list是否变化
    list(newValue) {
      newValue && newValue.length === 0 ? (this.showNoData = true) : (this.showNoData = false)
    }
  },
  computed: {
    btnText() {
      if (this.currentSelected) return '确认发送'
      return '请选择宝贝'
    }
  },
  methods: {
    // 是否被选中
    isSelected(item) {
      return this.currentSelected === item
    },
    // 选择
    choose(item) {
      console.log('choose', item)
      this.currentSelected = item
      this.commit()
    },
    // 滚动时
    monitorIsBottom() {
      const listView = $('.pick-list > ul')
      if (isScrollToBottom(listView)) {
        this.$emit('to-bottom')
      }
    },
    // 选中的提交
    commit() {
      console.log('commit>>>>.', this.currentSelected)
      if (!this.currentSelected) return
      this.$emit('selected', this.currentSelected)
    }
  },
  mounted() {
    //
  },
  components: {
    zStance: Stance,
    PickItemContainer
  }
}
</script>

<style lang="less" scoped>
  @import 'index.less';
</style>
